module.exports = __webpack_public_path__ + "img/LOGO.8ac506c6.png";